const escapeStringRegex = (string) => string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
const mongoRegex = (string, options) => ({ $regex: `.*${escapeStringRegex(string)}.*`, $options: options });
const mongoRegexI = (string) => mongoRegex(string, 'i');

const mongoNotRegex = (string, options) => {
  if (string.charAt(0) === '-') {
    return { $not: mongoRegex(string.substring(1), options) };
  }

  return mongoRegex(string, options);
};
const mongoListRegex = (string, options) => {
  const chunks = string.split(',');
  if (chunks.length === 1) { return mongoNotRegex(string, options); }

  return { $and: chunks.map((chunk) => mongoNotRegex(chunk, options)) };
};

export {
  mongoRegex, mongoRegexI, escapeStringRegex, mongoListRegex,
};
